
import IconInfo from '@svg/IconInfo.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Reusable callout banner for displaying informational, warning, or error messages.
 * Supports customisable icons, CTA buttons, and themed variants via the bannerType prop.
 */
@Component({
  components: {
    IconInfo,
  },
})
export default class CalloutBannerVue extends Vue {
  @Prop({ type: Boolean, default: true })
  public useDefaultIcon!: boolean
  @Prop({ type: Boolean, default: false })
  public isButtonCta!: boolean
  @Prop({ type: Boolean, default: true })
  public hasCta!: boolean
  @Prop({ type: Boolean, default: true })
  public isPrimaryTheme!: boolean
  @Prop({ type: String, default: '' })
  public calloutCopy!: string
  @Prop({ type: String, default: '' })
  public ctaCopy!: string
  @Prop({ type: String, default: '' })
  public ctaUrl!: string
  @Prop({ type: Function, default: () => {} })
  public ctaTracking!: Function
  @Prop({ type: String, default: '' })
  public customClassNames!: string
  @Prop({ type: String, default: '' })
  public bannerType!: string

  private onCtaClick() {
    this.$emit('on-cta-click')
  }

  // Bind @click.native to <router-link> tag will not work, hence changing to manual router change.
  private onCtaLinkClick() {
    if (typeof this.ctaTracking === 'function') {
      this.ctaTracking()
    }

    if (this.ctaUrl && this.ctaUrl !== '') {
      this.$router.push({ path: this.ctaUrl })
    }
    this.$emit('on-cta-link-click')
  }
}
